const f = require.context('@/form_types', true, /.*\.js$/)
let formTypes = {}
f.keys().forEach(key => {
  let mod = f(key)
  formTypes[mod.default.type] = mod.default
})

/*
const r = require.context('@/report_types', true, /.*\.js$/)
r.keys().forEach(key => {
  let mod = r(key)
  formTypes[`_REPORT_${mod.default.type}`] = mod.default
})
*/

export default {
  data() {
    return {
      formTypes
    }
  }
}
